import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import ProductsList from '../components/ProductsList';

const CategoryProducts = () => {
  return (
    <div className="App">
      <Header />
      <main>
        <ProductsList />
      </main>
      <Footer />
    </div>
  );
};

export default CategoryProducts;

